import React from 'react';
import { Route } from 'react-router-dom';
import UserList from './UserList';
import RouteMenu from 'mrf/view/MenuRoute';
import path from 'path';
import EditUserView from './EditUserView';
import UserForm from './UserForm';
import PropTypes from 'prop-types';

export default function User({ match }) {
    return (
        <RouteMenu match={match} indexComponent={UserList}>
            <Route path={path.join(match.url, 'view/:id')} component={EditUserView} />
            <Route path={path.join(match.url, 'new')} component={UserForm} />
        </RouteMenu>
    );
}

User.propTypes = {
    match: PropTypes.shape({
        url: PropTypes.string.isRequired,
    }).isRequired,
};